import { render, staticRenderFns } from "./BoardSelectorComponent.vue?vue&type=template&id=ab38329e&"
import script from "./BoardSelectorComponent.vue?vue&type=script&lang=ts&"
export * from "./BoardSelectorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab38329e')) {
      api.createRecord('ab38329e', component.options)
    } else {
      api.reload('ab38329e', component.options)
    }
    module.hot.accept("./BoardSelectorComponent.vue?vue&type=template&id=ab38329e&", function () {
      api.rerender('ab38329e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Board/BoardSelectorComponent.vue"
export default component.exports